import React, { Component } from "react";
import Paso1 from "./Paso1";
import Paso2 from "./Paso2";
import Paso3 from "./Paso3";
import Titulo from "../../../generico/TituloPagina";
import StepWizard from "react-step-wizard";
import { formatoSeparadorMilesValue } from '../../../generico/utils/FormatoInput';
import PrestamoPreaprobadoService from '../../../../services/solicitudes/PrestamoPreaprobadoService';
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import PrestamoInmediatoService from "../../../../services/solicitudes/PrestamoInmediatoService";


var prestamo = {
  minMonto: 500000,
  maxMonto: sessionStorage.getItem("saldoLineaPi"),
  monto: undefined,
  plazo: undefined,
  sucursal: undefined,
  interes: undefined

};
var montoCuota = {
  montoIngresado: undefined,
  sucursalId: undefined,
};


export default class PrestamoInmediato extends Component {
  constructor(props) {
    super(props);
    this.getPlazos = this.obtenerplazo.bind(this);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();

  }


  getInitialState = () => ({
    action: undefined,
    numeroTC: undefined,
    buscar: undefined,
    origen: undefined,
    disableSgte: true,
    idAhorro: undefined,
    listaPlazos: [],
    importe: formatoSeparadorMilesValue(sessionStorage.getItem("saldoLineaPi")),
    plazo: null,
    cuentaDeposito:null


  });


  componentDidMount() {
    this.obtenerplazo();
    // var saldoLinea = sessionStorage.getItem("saldoLinea");

  }
  //se obtiene listado de plazos
  obtenerplazo() {
    trackPromise(
      PrestamoPreaprobadoService.getPlazosPi()
        .then((response) => {
          var data = JSON.stringify(response.data);

          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {
            this.setState({ listaPlazos: jsonData.datos, plazo: jsonData.datos[0] });
            prestamo.plazo = jsonData.datos[0];
            this.habilitarBoton();

          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

        ));
  }

  cambiarColor(event, callback) {
    if (this.state.seleccionado === event.target.value) {
      this.setState({ seleccionado: null });
    } else {
      this.setState({ seleccionado: event.target.value });
      this.setState({ plazo: event.target.value });
      prestamo.plazo = event.target.value;
      montoCuota.plazo = event.target.value;
      callback && callback();
    }


  } 
  handleObtenerMonto(){
    this.obtenerMontoCuotaFinal(this.state.monto,);
  }
  obtenerMontoCuotaFinal = async (monto, plazo) => {

    //se control que monto ingresado sea manor a limite superior y mayor a 500000
    return new Promise(async (resolve) => {

      await trackPromise(
        PrestamoInmediatoService.getMontoCuota(monto, plazo)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {

              resolve(jsonData.datos)

            }
            else {
              resolve(null)
            }
          }

          ));

    })



  }



  returnPaso1(_importe, _cuota, _montoCuota, _interes, _cuentaDeposito, _datosMora, _idAhorro, _limiteSuperior) {

    this.setState({
      importe: _importe,
      plazo: _cuota,
      montoCuota: _montoCuota,
      interes: _interes,
      cuentaDeposito: _cuentaDeposito,
      datosMora: _datosMora,
      idAhorro: _idAhorro,
      limiteSuperior:_limiteSuperior
    })
    console.log(_importe, _cuota, _montoCuota);
  }


  returnPaso2(_idCredito, _idSolicitud, _depositoAporte, _moraAporte, _moraSolidaridad, _moraAporteConyuge, _moraSolidaridadConyuge, _mostrarObligaciones, _totalDesembolso, _limiteSuperior) {

    this.setState({
      idCredito: _idCredito,
      idSolicitud: _idSolicitud,
      depositoAporte: _depositoAporte,
      moraAporte: _moraAporte,
      moraSolidaridad: _moraSolidaridad,
      moraAporteConyuge: _moraAporteConyuge,
      moraSolidaridadConyuge: _moraSolidaridadConyuge,
      mostrarObligaciones: _mostrarObligaciones,
      totalDesembolso: _totalDesembolso,
      limiteSuperior:_limiteSuperior
      

    })
  }

  returnPaso3(_idCredito, _idSolicitud, _depositoAporte, _moraAporte, _moraSolidaridad, _moraAporteConyuge, _moraSolidaridadConyuge, _mostrarObligaciones, _totalDesembolso) {

    this.setState({
      idCredito: _idCredito,
      idSolicitud: _idSolicitud,
      depositoAporte: _depositoAporte,
      moraAporte: _moraAporte,
      moraSolidaridad: _moraSolidaridad,
      moraAporteConyuge: _moraAporteConyuge,
      moraSolidaridadConyuge: _moraSolidaridadConyuge,
      mostrarObligaciones: _mostrarObligaciones,
      totalDesembolso: _totalDesembolso

    })
  }






  render() {
    return (

      <div className="content-wrapper">
        <Titulo texto="Préstamo Digital" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{ zIndex: 0 }}>
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                      isLazyMount={true}
                    >
                      <Paso1
                        ref={this.paso1}
                        plazo={this.state.plazo}
                        listaPlazos={this.state.listaPlazos}
                        importe={this.state.importe}
                         limiteSuperior={this.state.limiteSuperior}
                        cambiarColor={this.cambiarColor.bind(this)}
                        returnPaso1={this.returnPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        importe={this.state.importe}
                        plazo={this.state.plazo}
                        montoCuota={this.state.montoCuota}
                        idCredito={this.state.idCredito}
                        idSolicitud={this.state.idSolicitud}
                        interes={this.state.interes}
                        cuentaDeposito={this.state.cuentaDeposito}
                        idAhorro={this.state.idAhorro}
                        depositoAporte={this.state.depositoAporte}
                        moraAporte={this.state.moraAporte}
                        moraSolidaridad={this.state.moraSolidaridad}
                        moraAporteConyuge={this.state.moraAporteConyuge}
                        moraSolidaridadConyuge={this.state.moraSolidaridadConyuge}
                        totalDesembolso={this.state.totalDesembolso}
                        mostrarObligaciones={this.state.mostrarObligaciones}
                         limiteSuperior={this.state.limiteSuperior}
                        returnPaso2={this.returnPaso2.bind(this)}
                      />

                      <Paso3
                        ref={this.paso3}
                        cuentaDeposito={this.state.cuentaDeposito}
                        importe={this.state.importe}
                        idCredito={this.state.idCredito}
                        idSolicitud={this.state.idSolicitud}
                        plazo={this.state.plazo}
                        montoCuota={this.state.montoCuota}
                        interes={this.state.interes}
                        depositoAporte={this.state.depositoAporte}
                        moraAporte={this.state.moraAporte}
                        moraSolidaridad={this.state.moraSolidaridad}
                        moraAporteConyuge={this.state.moraAporteConyuge}
                        moraSolidaridadConyuge={this.state.moraSolidaridadConyuge}
                        totalDesembolso={this.state.totalDesembolso}
                        mostrarObligaciones={this.state.mostrarObligaciones}
                        returnPaso3={this.returnPaso3.bind(this)}
                      />

                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
